export class QObjDBFieldValue {
  constructor() {
    this.fFieldDef = null;
    this.fFieldValue = null;
  }

  InitFieldValue(fieldDef) {
    this.fFieldDef = fieldDef;
  }

  GetFieldDef() {
    return this.fFieldDef;
  }

  SetValue(fieldValue) {
    this.fFieldValue = fieldValue;
  }

  GetValue() {
    return this.fFieldValue;
  }
}
